import { useSirenEntity } from '~/utility/BinSentry-ui-utility';
import _ from 'lodash';
import { DateTime } from 'luxon';

export default function useOrderMicrosoftFinanceAndOperationsSyncState({ order }) {
  const orderNumber = order?.properties?.orderNumber;
  const { entity: integrations, loading: loadingIntegrations }
    = useSirenEntity({ href: order?.getLink('https://api.binsentry.com/rel/integrations')?.href });
  const { entity: fAndOIntegration, loading: loadingFAndO }
    = useSirenEntity({ href: integrations?.getSubEntity('https://api.binsentry.com/rel/microsoft-finance-and-operations-integration')?.href });

  if (!order) {
    return null;
  }

  const loading = loadingIntegrations || loadingFAndO;
  const latestSyncHistory = _.last(fAndOIntegration?.properties.syncHistory);
  let message;
  let state;
  if (!loading && latestSyncHistory && latestSyncHistory?.state !== 'success') {
    state = 'error';
    message = `Send to F&O failed${latestSyncHistory?.error ? `: ${latestSyncHistory.error}` : ''}`;
  } else if (!orderNumber || !latestSyncHistory) {
    state = 'not-synced';
    message = ['draft', 'ready'].includes(order.properties.state)
      ? 'Order cannot be sent to F&O, schedule order to send'
      : 'Not sent to F&O';
  } else if (loading || latestSyncHistory?.state === 'success') {
    state = 'success';
    const createdAt = latestSyncHistory?.createdAt;
    message = loading ? '' : `Last sent to F&O: ${DateTime.fromISO(createdAt).toLocaleString(_.omit(DateTime.DATETIME_FULL, 'timeZoneName'))}`;
  }
  return { loading, message, state, latestSyncHistory, fAndOIntegration };
}
